// import React, { useState, useEffect } from 'react';
// import {
//   Button,
//   Modal,
//   Form,
//   Table,
//   Spinner,
// } from 'react-bootstrap';
// import { FaSearch, FaTrash } from 'react-icons/fa';
// import { Pencil } from 'lucide-react';
// import Swal from 'sweetalert2';
// import 'sweetalert2/dist/sweetalert2.min.css';

// const API_URL = 'https://kaasbackend.vetrinahealthcare.com/master/designations/';

// const DesignationManager = () => {
//   const [designations, setDesignations] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [showModal, setShowModal] = useState(false);
//   const [designationInput, setDesignationInput] = useState('');
//   const [editItem, setEditItem] = useState(null);
//   const [isPageLoading, setIsPageLoading] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isDeletingId, setIsDeletingId] = useState(null);

//   const token = localStorage.getItem('jwttoken');

//   useEffect(() => {
//     fetchDesignations();
//   }, []);

//   const fetchDesignations = async () => {
//     setIsPageLoading(true);
//     try {
//       const res = await fetch(API_URL, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!res.ok) {
//         const error = await res.json();
//         Swal.fire('Error', error.detail || 'Failed to fetch designations', 'error');
//         return;
//       }

//       const data = await res.json();
//       setDesignations(data);
//     } catch (err) {
//       console.error(err);
//       Swal.fire('Error', 'Network error', 'error');
//     } finally {
//       setIsPageLoading(false);
//     }
//   };

//   const handleShowModal = () => {
//     setDesignationInput('');
//     setEditItem(null);
//     setShowModal(true);
//   };

//   const handleClose = () => {
//     setDesignationInput('');
//     setEditItem(null);
//     setShowModal(false);
//   };

//   const handleAddOrUpdate = async () => {
//     const trimmed = designationInput.trim();
//     if (!trimmed) return;

//     setIsLoading(true);

//     if (editItem) {
//       // PATCH
//       try {
//         const res = await fetch(`${API_URL}${editItem.id}/`, {
//           method: 'PATCH',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({ name: trimmed }),
//         });

//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire('Error', error.detail || 'Failed to update', 'error');
//           return;
//         }

//         Swal.fire('Updated!', 'Designation updated successfully.', 'success');
//         fetchDesignations();
//         handleClose();
//       } catch (err) {
//         console.error(err);
//         Swal.fire('Error', 'Network error', 'error');
//       } finally {
//         setIsLoading(false);
//       }
//     } else {
//       // POST
//       try {
//         const res = await fetch(API_URL, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({ name: trimmed }),
//         });

//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire('Error', error.detail || 'Failed to add designation', 'error');
//           return;
//         }

//         Swal.fire('Added!', 'Designation added successfully.', 'success');
//         fetchDesignations();
//         handleClose();
//       } catch (err) {
//         console.error(err);
//         Swal.fire('Error', 'Network error', 'error');
//       } finally {
//         setIsLoading(false);
//       }
//     }
//   };

//   const handleEdit = (designation) => {
//     setDesignationInput(designation.name);
//     setEditItem(designation);
//     setShowModal(true);
//   };

//   const handleDelete = async (designation) => {
//     const confirm = await Swal.fire({
//       title: 'Are you sure?',
//       text: `Delete "${designation.name}"?`,
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#d33',
//       confirmButtonText: 'Yes, delete it!',
//     });

//     if (confirm.isConfirmed) {
//       setIsDeletingId(designation.id);

//       try {
//         const res = await fetch(`${API_URL}${designation.id}/`, {
//           method: 'DELETE',
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire('Error', error.detail || 'Failed to delete', 'error');
//           return;
//         }

//         Swal.fire('Deleted!', 'Designation deleted successfully.', 'success');
//         fetchDesignations();
//       } catch (err) {
//         console.error(err);
//         Swal.fire('Error', 'Network error', 'error');
//       } finally {
//         setIsDeletingId(null);
//       }
//     }
//   };

//   const filteredDesignations = designations.filter((d) =>
//     d.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div>
//       <h4 className="mb-3 text-center">Manage Designations</h4>

//       <div className="d-flex justify-content-between mb-3">
//         <div
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             position: 'relative',
//             width: '300px',
//           }}
//         >
//           <FaSearch
//             style={{
//               position: 'absolute',
//               left: '10px',
//               color: '#888',
//             }}
//           />
//           <input
//             type="text"
//             placeholder="Search Designation..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             style={{
//               padding: '8px 10px 8px 35px',
//               border: '1px solid #ddd',
//               borderRadius: '5px',
//               width: '100%',
//             }}
//           />
//         </div>

//         <Button
//           onClick={handleShowModal}
//           style={{
//             background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
//             color: 'white',
//             border: 'none',
//           }}
//         >
//           + Add Designation
//         </Button>
//       </div>

//       {isPageLoading ? (
//         <div className="text-center my-5">
//           <Spinner animation="border" variant="primary" />
//         </div>
//       ) : (
//         <Table striped hover responsive>
//           <thead>
//             <tr>
//               <th>ID</th>
//               <th>Designation</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredDesignations.length > 0 ? (
//               filteredDesignations.map((d) => (
//                 <tr key={d.id}>
//                   <td>{d.id}</td>
//                   <td>{d.name}</td>
//                   <td>
//                     <Button
//                       variant="white"
//                       size="sm"
//                       className="me-2"
//                       style={{
//                         background: 'none',
//                         border: 'none',
//                         color: '#7366ff',
//                         cursor: 'pointer',
//                       }}
//                       onClick={() => handleEdit(d)}
//                     >
//                       <Pencil size={20} />
//                     </Button>
//                     <Button
//                       variant="white"
//                       size="sm"
//                       className="me-2"
//                       style={{
//                         background: 'none',
//                         border: 'none',
//                         color: '#ff5370',
//                         cursor: 'pointer',
//                       }}
//                       onClick={() => handleDelete(d)}
//                       disabled={isDeletingId === d.id}
//                     >
//                       {isDeletingId === d.id ? (
//                         <Spinner size="sm" animation="border" />
//                       ) : (
//                         <FaTrash size={20} />
//                       )}
//                     </Button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="3" className="text-center">
//                   No designations found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </Table>
//       )}

//       <Modal show={showModal} onHide={handleClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>{editItem ? 'Edit' : 'Add'} Designation</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form.Control
//             type="text"
//             placeholder="Enter designation name"
//             value={designationInput}
//             onChange={(e) => setDesignationInput(e.target.value)}
//           />
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             style={{
//               background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
//               color: 'white',
//               border: 'none',
//             }}
//             onClick={handleAddOrUpdate}
//             disabled={isLoading}
//           >
//             {isLoading ? (
//               <Spinner size="sm" animation="border" />
//             ) : (
//               editItem ? 'Update Designation' : 'Add Designation'
//             )}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default DesignationManager;


import React, { useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Form,
  Table,
  Spinner,
  Pagination,
} from 'react-bootstrap';
import { FaSearch, FaTrash } from 'react-icons/fa';
import { Pencil } from 'lucide-react';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const API_URL = 'https://kaasbackend.vetrinahealthcare.com/master/designations/';

const DesignationManager = () => {
  const [designations, setDesignations] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [designationInput, setDesignationInput] = useState('');
  const [editItem, setEditItem] = useState(null);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeletingId, setIsDeletingId] = useState(null);
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const token = localStorage.getItem('jwttoken');

  useEffect(() => {
    fetchDesignations();
  }, []);

  const fetchDesignations = async () => {
    setIsPageLoading(true);
    try {
      const res = await fetch(API_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) {
        const error = await res.json();
        Swal.fire('Error', error.detail || 'Failed to fetch designations', 'error');
        return;
      }

      const data = await res.json();
      setDesignations(data);
      setCurrentPage(1); // Reset to first page when data changes
    } catch (err) {
      console.error(err);
      Swal.fire('Error', 'Network error', 'error');
    } finally {
      setIsPageLoading(false);
    }
  };

  // Filter designations based on search term
  const filteredDesignations = designations.filter((d) =>
    d.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredDesignations.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredDesignations.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleShowModal = () => {
    setDesignationInput('');
    setEditItem(null);
    setShowModal(true);
  };

  const handleClose = () => {
    setDesignationInput('');
    setEditItem(null);
    setShowModal(false);
  };

  const handleAddOrUpdate = async () => {
    const trimmed = designationInput.trim();
    if (!trimmed) return;

    setIsLoading(true);

    if (editItem) {
      // PATCH
      try {
        const res = await fetch(`${API_URL}${editItem.id}/`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ name: trimmed }),
        });

        if (!res.ok) {
          const error = await res.json();
          Swal.fire('Error', error.detail || 'Failed to update', 'error');
          return;
        }

        Swal.fire('Updated!', 'Designation updated successfully.', 'success');
        fetchDesignations();
        handleClose();
      } catch (err) {
        console.error(err);
        Swal.fire('Error', 'Network error', 'error');
      } finally {
        setIsLoading(false);
      }
    } else {
      // POST
      try {
        const res = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ name: trimmed }),
        });

        if (!res.ok) {
          const error = await res.json();
          Swal.fire('Error', error.detail || 'Failed to add designation', 'error');
          return;
        }

        Swal.fire('Added!', 'Designation added successfully.', 'success');
        fetchDesignations();
        handleClose();
      } catch (err) {
        console.error(err);
        Swal.fire('Error', 'Network error', 'error');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleEdit = (designation) => {
    setDesignationInput(designation.name);
    setEditItem(designation);
    setShowModal(true);
  };

  const handleDelete = async (designation) => {
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: `Delete "${designation.name}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (confirm.isConfirmed) {
      setIsDeletingId(designation.id);

      try {
        const res = await fetch(`${API_URL}${designation.id}/`, {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          const error = await res.json();
          Swal.fire('Error', error.detail || 'Failed to delete', 'error');
          return;
        }

        Swal.fire('Deleted!', 'Designation deleted successfully.', 'success');
        fetchDesignations();
      } catch (err) {
        console.error(err);
        Swal.fire('Error', 'Network error', 'error');
      } finally {
        setIsDeletingId(null);
      }
    }
  };

  return (
    <div>
      <h4 className="mb-3 text-center">Manage Designations</h4>

      <div className="d-flex justify-content-between mb-3">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            width: '300px',
          }}
        >
          <FaSearch
            style={{
              position: 'absolute',
              left: '10px',
              color: '#888',
            }}
          />
          <input
            type="text"
            placeholder="Search Designation..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              padding: '8px 10px 8px 35px',
              border: '1px solid #ddd',
              borderRadius: '5px',
              width: '100%',
            }}
          />
        </div>

        <Button
          onClick={handleShowModal}
          style={{
            background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
            color: 'white',
            border: 'none',
          }}
        >
          + Add Designation
        </Button>
      </div>

      {isPageLoading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Designation</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((d, index) => (
                  <tr key={d.id}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{d.name}</td>
                    <td>
                      <Button
                        variant="white"
                        size="sm"
                        className="me-2"
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#7366ff',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleEdit(d)}
                      >
                        <Pencil size={20} />
                      </Button>
                      <Button
                        variant="white"
                        size="sm"
                        className="me-2"
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#ff5370',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleDelete(d)}
                        disabled={isDeletingId === d.id}
                      >
                        {isDeletingId === d.id ? (
                          <Spinner size="sm" animation="border" />
                        ) : (
                          <FaTrash size={20} />
                        )}
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center">
                    No designations found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* Pagination */}
          {filteredDesignations.length > itemsPerPage && (
            <div className="d-flex justify-content-center mt-3">
              <Pagination>
                <Pagination.First 
                  onClick={() => paginate(1)} 
                  disabled={currentPage === 1} 
                />
                <Pagination.Prev 
                  onClick={() => paginate(currentPage - 1)} 
                  disabled={currentPage === 1} 
                />
                
                {[...Array(totalPages)].map((_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === currentPage}
                    onClick={() => paginate(index + 1)}
                    style={{
                      backgroundColor: index + 1 === currentPage ? 'orange' : '',
                      borderColor: index + 1 === currentPage ? 'orange' : '',
                      color: index + 1 === currentPage ? 'white' : '',
                    }}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
                
                <Pagination.Next 
                  onClick={() => paginate(currentPage + 1)} 
                  disabled={currentPage === totalPages} 
                />
                <Pagination.Last 
                  onClick={() => paginate(totalPages)} 
                  disabled={currentPage === totalPages} 
                />
              </Pagination>
            </div>
          )}
        </>
      )}

      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{editItem ? 'Edit' : 'Add'} Designation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            type="text"
            placeholder="Enter designation name"
            value={designationInput}
            onChange={(e) => setDesignationInput(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="primary"
            style={{
              background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
              color: 'white',
              border: 'none',
            }}
            onClick={handleAddOrUpdate}
            disabled={isLoading}
          >
            {isLoading ? (
              <Spinner size="sm" animation="border" />
            ) : (
              editItem ? 'Update Designation' : 'Add Designation'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DesignationManager;